import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import TagAddTrigger from './TagAddTrigger'

export { TagAddTrigger }

// export default Loadable(() => import('./TagAdd_OLD'))
export default Loadable(() => import('./TagAdd'))
